import {
  IErrorApiResponse,
  IFormConfigurationContext,
  IOptionItem,
  ISuccessApiResponse,
} from '@wyz/types';
import { UseQueryResult } from '@wyz/utils';
import { createContext } from 'react';
import {
  IBrand,
  ISeasonOptionItem,
  ISupplierTypeOptionItem,
  IVehicleTypeGroupList,
  IVehicleTypeGroupsOptionItem,
} from '~/common/types';
import { IPurchaseErrorResponse, ISeason } from '~/purchase/types';

export type IFormContext = {
  mode: IFormConfigurationContext['mode'];
  seasons: { optionItems: Array<ISeasonOptionItem> } & UseQueryResult<
    ISuccessApiResponse<ISeason[]>,
    IErrorApiResponse
  >;
  vehicleTypeGroups: {
    optionItems: Array<IVehicleTypeGroupsOptionItem>;
  } & UseQueryResult<IVehicleTypeGroupList, IPurchaseErrorResponse>;

  pricingConfigurationTypes: { optionItems: Array<IOptionItem> };
  supplierTypes: Array<ISupplierTypeOptionItem>;
  brands: {
    all: Array<IBrand>;
  };
};
export const FormContext = createContext<IFormContext | undefined>(undefined);
